import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import {
  Collapse,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { LayoutMenuOption } from "developer/edit/hooks/useInsertionMenuOptions";
import React, { useCallback, useState } from "react";
import FieldListItem from "./FieldListItem";

type LayoutListItemProps = {
  option: LayoutMenuOption;
  isDrawerOpen: boolean;
  isSelected?: boolean;
  onClick?: (e: any) => void;
};

const LayoutListItem: React.FC<LayoutListItemProps> = (props) => {
  const { onClick, option, isSelected, isDrawerOpen } = props;
  const [isExpanded, setIsExpanded] = useState<boolean>(
    option.expanded ?? false
  );

  const handleClickOption = useCallback(
    (event: any) => {
      setIsExpanded((isExpanded) => !isExpanded);
      onClick?.(event);
    },
    [onClick]
  );

  const hasNestedOptions = option.items && option.items?.length > 0;

  const _isSelected =
    isSelected &&
    (option.mode !== "insert-field" ||
      (option.mode === "insert-field" && !isExpanded));

  return (
    <ListItem
      key={option.id}
      disablePadding
      divider
      sx={{
        display: "block",
      }}
    >
      <ListItemButton
        selected={_isSelected}
        onClick={handleClickOption}
        sx={{
          minHeight: 40,
          justifyContent: isDrawerOpen ? "initial" : "center",
          px: 2.5,
          borderLeft: (theme) =>
            _isSelected ? `4px solid ${theme.palette.primary.main}` : undefined,
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: isDrawerOpen ? 3 : "auto",
            justifyContent: "center",
          }}
        >
          {option.icon}
        </ListItemIcon>
        <ListItemText
          primary={option.label}
          sx={{ opacity: isDrawerOpen ? 1 : 0 }}
        />
        {hasNestedOptions &&
          isDrawerOpen &&
          (isExpanded ? (
            <ExpandLess color="action" />
          ) : (
            <ExpandMore color="action" />
          ))}
      </ListItemButton>
      {hasNestedOptions && (
        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
          {option.items?.map((option) => (
            <FieldListItem
              key={option.id}
              isDrawerOpen={isDrawerOpen}
              option={option}
              isSelected={option.selected}
              onClick={option.onClick}
            />
          ))}
        </Collapse>
      )}
    </ListItem>
  );
};

export default LayoutListItem;
